"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterLimitNote = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var CharacterCount_1 = require("../CharacterCount");
var CharacterLimit_1 = require("../CharacterLimit");
var Note = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  label: CharacterLimitNote;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  label: CharacterLimitNote;\n"])));
var CharacterLimitNote = function (_a) {
    var color = _a.color, value = _a.value, maxLength = _a.maxLength, minLength = _a.minLength, className = _a.className;
    return (react_1.default.createElement(Note, { className: className },
        react_1.default.createElement(CharacterLimit_1.CharacterLimit, { color: color, minLength: minLength, maxLength: maxLength }),
        react_1.default.createElement(CharacterCount_1.CharacterCount, { color: color, value: value })));
};
exports.CharacterLimitNote = CharacterLimitNote;
var templateObject_1;
